import React, { useState, useEffect, useCallback, useRef } from "react";

import add_moneyIcon from "../../../assets/img/icon/add_money-icon.png";
import monnifyIcon from "../../../assets/img/icon/monnify-logo.jpeg";
import paychanguIcon from "../../../assets/img/icon/paychangu.png";
import { FaAngleLeft, FaAngleDown } from "react-icons/fa6";
import { BsBank } from "react-icons/bs";
import { FiCopy, FiCheckCircle } from "react-icons/fi";

import "./addMoney.css";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ReactFlagsSelect from "react-flags-select";
import {
  fetchWallets,
  formatLabel,
  getFormattedAmount,
  initializeFunding,
  updateCanceledTransactionProcess,
  updateTransactionProcess,
} from "../../../actions/payments";
import { useDispatch, useSelector } from "react-redux";
import { getAuthenticatedUser } from "../../../actions/auth";
import { fetchSupportedPaymentGateways } from "../../../actions";
import { Modal } from "bootstrap";
import PayazaCheckout from "payaza-web-sdk";
import { handleValidationError } from "../../../actions/validation";
import { ShieldCheck } from "lucide-react";
import { FaInfoCircle } from "react-icons/fa";
import { formatAmount } from "../../../helpers/currency";


const AddMoney = ({ userDetails }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedPaymentProvider, setSelectedPaymentProvider] = useState(null);
  const [appliedFees, setAppliedFees] = useState(null);
  const [showFeeDetails, setShowFeeDetails] = useState(false);
  const [walletSelect, setWalletSelect] = useState("");
  const [loading, setLoading] = useState(false);
  const [gatewayLoading, setGatewayLoading] = useState(false);
  const [isEdited, setIsEdited] = useState(false);
  const [amount, setAmount] = useState("");
  const [totalFees, setTotalFees] = useState(0);
  const [currencyCode, setCurrencyCode] = useState("NGN");
  const [selectedCountry, setSelectedCountry] = useState("NG");
  const { currencyOptions, allowedCountries } = useSelector(
    (state) => state.country,
  );
  const [userWallets, setUserWallets] = useState([]);
  const [virtualAccount, setVirtualAccount] = useState({
    bank_name: userDetails?.default_virtual_account?.bank_name || "",
    account_number: userDetails?.default_virtual_account?.account_number || "",
    account_name: userDetails?.default_virtual_account?.account_name || "",
    customer_id: "",
    virtual_nuban_id: "",
    status: userDetails?.default_virtual_account?.status || "",
    total_fees: "",
    amount_to_be_credited: "",
  });
  const userLocalWallet =
    userWallets &&
    userWallets.find(
      (wallet) =>
        wallet.currency_code === userDetails?.default_wallet?.currency_code,
    );
  
  const nigerianUser = userDetails?.country && ['nigeria', 'ng', 'nga'].includes(userDetails?.country.toLowerCase());
  
  const dispatch = useDispatch();
  const [gateways, setGateways] = useState([]);
  
  const selectedGatewayDetails = gateways && selectedMethod && gateways.find((gateway) => gateway.code_name === selectedMethod);
  const closeMonnifyBtnRef = React.useRef(null);
  const closeAnchorBtnRef = useRef(null);
  const [paymentVerificationLoading, setPaymentVerificationLoading] = useState(false);
  // console.log(selectedGatewayDetails);

  const supportedPaymentGateways = async () => {
    try {
      setGatewayLoading(true);
      const response = await fetchSupportedPaymentGateways();
      setGateways(response.data.providers.filter(provider => {
          const vaFailed = !userDetails?.virtual_account_holder || userDetails?.virtual_account_holder?.kyc_status === 'failed';
          if (vaFailed) {
            return false;
          }
          return true;
      }));
    } catch (error) {
      // console.error("Failed to fetch gateways:", error);
    } finally {
      setGatewayLoading(false);
    }
  };



  useEffect(() => {
    userLocalWallet && supportedPaymentGateways(userLocalWallet?.ref_id);
  }, [userLocalWallet]);

  const getCurrencyInfoByCountryCode = (code) => {
    return currencyOptions?.find((c) => c.countryCode === code) || {};
  };

  const customLabels = Object.fromEntries(
    currencyOptions
      .filter((option) =>
        allowedCountries.includes(option.countryCode.toUpperCase()),
      )
      .map((option) => [option.countryCode, option.currencyCode]),
  );

  useEffect(() => {
    if (userLocalWallet && walletSelect === "") {
      setWalletSelect(userLocalWallet.id);
    }
  }, [userLocalWallet, walletSelect]);

  // const fetchAllWallets = async () => {
  //     setLoading(true);
  //     try {
  //         const response = await fetchWallets();
  //         // const data = await getAuthenticatedUser(dispatch);

  //         const wallets = response.data.wallets;
  //         // const wallets = data.all_wallets;

  //         // Enrich wallet data with currencyOptions
  //         const enrichedWallets = wallets.map((wallet) => {
  //             const match = currencyOptions.find(opt => opt.currencyCode === wallet.currency);

  //             return {
  //                 ...wallet,
  //                 currencyName: match?.currencyName,
  //                 // countryCode: match?.countryCode,
  //                 flag: match?.flagUrl,
  //                 currencySymbol: match?.symbol,
  //             };
  //         });

  //         setUserWallets(enrichedWallets);
  //     } catch (error) {
  //         console.error("Error fetching wallets:", error);
  //     } finally {
  //         setLoading(false);
  //     }
  // };

  const wallets = userDetails?.wallet;
  const getUserWallets = (wallets) => {
    setLoading(true);

    if (!wallets || wallets.length === 0) return;

    const enrichedWallets = wallets.map((wallet) => {
      const match = currencyOptions.find(
        (opt) => opt.currencyCode === wallet.currency_code,
      );
      return {
        ...wallet,
        currencyName: match?.currencyName,
        flag: match?.flagUrl,
        currencySymbol: match?.symbol,
      };
    });
    setUserWallets(enrichedWallets);
    setLoading(false);
  };

  const triggerUserAuth = async () => {
    await getAuthenticatedUser(dispatch);
  };

  useEffect(() => {
    if (currencyOptions.length > 0) {
      getUserWallets(wallets);
      // fetchAllWallets();
    }
  }, [currencyOptions]);

  // useEffect(() => {
  //   const scriptId = "monnify-sdk";
  //   let script = document.getElementById(scriptId);

  //   if (!script) {
  //     script = document.createElement("script");
  //     script.src = "https://sdk.monnify.com/plugin/monnify.js";
  //     script.async = true;
  //     script.id = scriptId;
  //     document.body.appendChild(script);
  //   }
  // }, []);

  useEffect(() => {
    const monnifyScript = document.createElement("script");
    monnifyScript.src = "https://sdk.monnify.com/plugin/monnify.js";
    monnifyScript.id = "monnifyScript";
    monnifyScript.async = true;
    document.body.appendChild(monnifyScript);

    return () => {
      const existingScript = document.getElementById("monnifyScript");
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  useEffect(() => {
    const paychangu = document.createElement("script");
    paychangu.src = "https://in.paychangu.com/js/popup.js";
    paychangu.id = "paychangu";
    paychangu.async = true;
    document.body.appendChild(paychangu);

    return () => {
      const existingScript = document.getElementById("paychangu");
      if (existingScript) {
        document.body.removeChild(existingScript);
      }
    };
  }, []);

  useEffect(() => {
    const modalElement = document.getElementById("addMoneyModal");
    if (!modalElement) return;

    const handleModalHide = () => {
      setAmount("");
      setIsEdited(false);
      setTotalFees(0);
      setAppliedFees(null);
      setShowFeeDetails(false);
    };

    modalElement.addEventListener("hidden.bs.modal", handleModalHide);

    return () => {
      modalElement.removeEventListener("hidden.bs.modal", handleModalHide);
    };
  }, []);

  const reloadMonnifyScript = () => {
    const scriptId = "monnify-sdk";

    // Safely remove old script after checking it's actually part of the DOM
    const existingScript = document.getElementById(scriptId);
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.removeChild(existingScript);
      // console.log("Old Monnify SDK removed.");
    }

    // Append fresh script
    const newScript = document.createElement("script");
    newScript.src = "https://sdk.monnify.com/plugin/monnify.js";
    newScript.async = true;
    newScript.id = scriptId;

    document.body.appendChild(newScript);
    // console.log("Monnify SDK reloaded.");
  };

  const handleMethodChange = (method) => {
    setSelectedMethod(method);
  };

  const handleWalletSelectChange = (event) => {
    const selectedId = event.target.value;
    console.log("Selected Wallet ID:", selectedId);
    setIsEdited(true);

    // Find the selected payment option
    const selectedOption = userWallets.find(
      (option) => String(option.id) === selectedId,
    );
    setWalletSelect(selectedOption);

    if (selectedOption) {
      setCurrencyCode(selectedOption.currency);
      setSelectedCountry(selectedOption.countryCode);
    }
  };

  const handleAmountChange = (event) => {
    const txnAmount = event.target.value;
    setAmount(txnAmount);
    setIsEdited(true);
    computeTransactionFee(txnAmount, selectedPaymentProvider);
  };
  
  const computeTransactionFee = (txnAmount, paymentProvider) => {
    let computedFee = 0;
    const applicableFeeConfigs = paymentProvider?.fee_configurations.filter(feeConfig => {
      if(Number(feeConfig.minimum_transaction_amount) <= txnAmount && (
        feeConfig.maximum_transaction_amount === null || feeConfig.minimum_transaction_amount > txnAmount
      )) return true;
      return false;
    });
    setAppliedFees(applicableFeeConfigs?.map(fee => {
      const feeAmount = calculateFee(txnAmount, fee);
      computedFee += feeAmount;
      return {
        label: fee.label,
        description: fee.description,
        currency: fee.currency,
        totalAmount: feeAmount,
      }
    }));
    setTotalFees(computedFee);
  }

  const calculateFee = (amount, feeConfig) => {
    const fee = feeConfig.fiat_fee + ((amount * feeConfig.fee_percentage_value) / 100);
    const roundedFee = (Math.ceil(fee * 100))/100;
      if (feeConfig.minimum_fee) return Math.max(roundedFee, feeConfig.minimum_fee);
      if (feeConfig.maximum_cap_fee) return Math.min(roundedFee, feeConfig.maximum_cap_fee);
      return roundedFee;
  }

  const handleCountrySelect = (code) => {
    setSelectedCountry(code);
    setCurrencyCode(getCurrencyInfoByCountryCode(code).currencyCode);
  };

  const handleCanceledTnx = async (tnx_refID) => {
    try {
      const response = await updateCanceledTransactionProcess(tnx_refID);
      // console.log(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching wallets:", error);
      return error;
    }
  };
  const handleTnxProcess = async (tnx_refID, credentials) => {
    try {
      const response = await updateTransactionProcess(tnx_refID, credentials);
      await getAuthenticatedUser(dispatch);
      // console.log(response.message);
      return response.message;
    } catch (error) {
      // console.error("Error fetching wallets:", error);
      return error;
    }
  };

  const handleMonnifyPayment = async (data) => {
    const monnify = window.MonnifySDK;
    if (!monnify) {
      toast.error("Payment initialization failed. Please try again.");
      return;
    }

    monnify.initialize({
      amount: parseFloat(data.amount),
      currency: data.currency,
      reference: data.payment_reference,
      customerFullName: userDetails?.bank_account[0]?.account_name,
      customerEmail: userDetails?.email,
      apiKey: process.env.REACT_APP_MONNIFY_API_KEY,
      contractCode: process.env.REACT_APP_MONNIFY_CONTRACT_CODE,
      paymentDescription: "Airtime purchase",
      metadata: { name: userDetails?.last_name },
      onLoadStart: () => console.log("Monnify Loading..."),
      onLoadComplete: () => console.log("Monnify Loaded"),
      onComplete: (res) => {
        if (res.status === "SUCCESS") {
          const credentials = {
            transaction_reference: res.transactionReference,
            payment_reference: data.payment_reference,
            provider: (
              selectedGatewayDetails?.code_name || selectedMethod
            ).toLowerCase(),
          };
          // console.log(res)

          setAmount("");
          setWalletSelect("");
          closeMonnifyBtnRef.current.click();

          navigate(
            `/user/add_money/verify?credentials=${encodeURIComponent(
              JSON.stringify(credentials),
            )}`,
          );

          setTimeout(() => window.location.reload(), 10000);
        }
      },
      onClose: (callbackData) => {
        const credentials = {
          transaction_reference: callbackData.transactionReference,
          payment_reference: data.payment_reference,
          provider: (
            selectedGatewayDetails?.code_name || selectedMethod
          ).toLowerCase(),
        };
        // console.log(data);

        if (callbackData.status === "FAILED") {
          navigate(
            `/user/add_money/verify?credentials=${encodeURIComponent(
              JSON.stringify(credentials),
            )}`,
          );
          setTimeout(() => window.location.reload(), 10000);
          closeMonnifyBtnRef.current.click();
          setAmount("");
        } else if (callbackData.status === "SUCCESS") {
          navigate(
            `/user/add_money/verify?credentials=${encodeURIComponent(
              JSON.stringify(credentials),
            )}`,
          );
        } else if (callbackData.paymentStatus === "USER_CANCELLED") {
          toast.warn(`${formatLabel(selectedMethod)} modal closed.`);
          setTimeout(() => window.location.reload(), 3000);
          closeMonnifyBtnRef.current.click();
          setAmount("");
        }
      },
    });
  };

  const updateTransactionStatus = (data) => {
    const credentials = {
      payment_reference: data.reference,
      provider: data.provider.toLowerCase(),
    };
    setAmount("");
    setWalletSelect("");
    closeMonnifyBtnRef.current.click();
    navigate(
      `/user/add_money/verify?credentials=${encodeURIComponent(
        JSON.stringify(credentials),
      )}`,
    );
    setTimeout(() => window.location.reload(), 5000);
  };

  const handlePayAzaPayment = async (data) => {
    const payazaCheckout = new PayazaCheckout({
      merchant_key: process.env.REACT_APP_PAYAZA_PUBLIC_KEY,
      connection_mode: process.env.REACT_APP_ENVIRONMENT == "production" ? "Live" : "Test",
      checkout_amount: Number(data.amount),
      currency_code: data.currency,
      transaction_reference: data.payment_reference,
      email_address: userDetails?.email,
      first_name: userDetails?.first_name,
      last_name: userDetails?.last_name,
      phone_number: userDetails?.phone,
      virtual_account_configuration: {
        expires_in_minutes: 60,
      },
      // optional
      additional_details: {
        user_id: userDetails?.id,
      },

      onClose: function () {
        // console.log("PayAza modal closed");
        toast("Payment session exited successfully.");
        setTimeout(() => {
          setLoading(false);
        }, 5000);
      },
    });
    
    payazaCheckout.setCallback(function(callbackResponse){
      console.log(callbackResponse);
      if (callbackResponse.type == "error") {
        const errorMsg = callbackResponse.data?.message;
        const details = callbackResponse.data?.errors
          ?.map(e => `${e.field}: ${e.errors?.join(", ")}`)
          .join("; ");
        toast.error(details ? `${errorMsg} (${details})` : (errorMsg || "An error occured when loading the checkout modal."));
        setLoading(false);
        return;
      }
      // console.log("Payaza Reference", callbackResponse.data.payaza_reference);
      if (callbackResponse.type == "success" && callbackResponse.data) {
        const credentials = {
          transaction_reference: callbackResponse.data.payaza_reference,
          payment_reference: data.payment_reference,
          provider: data.provider,
        };
        closeMonnifyBtnRef.current.click();
        navigate(`/user/add_money/verify?credentials=${encodeURIComponent(JSON.stringify(credentials))}`);
        // setTimeout(() => window.location.reload(), 5000);
      }
    });

    payazaCheckout.showPopup();
  };

  const handlePaychanguPayment = async (data) => {
    const credentials = {
      provider: data.provider,
      transaction_reference: data.transaction_reference,
      payment_reference: data.payment_reference,
    };
    try {
      if (window.PaychanguCheckout) {
        window.PaychanguCheckout({
          public_key: process.env.REACT_APP_PAYCHANGU_PUBLIC_KEY,
          tx_ref: credentials.payment_reference,
          amount: parseFloat(data.amount),
          currency: data.currency,
          callback_url: `${
            process.env.REACT_APP_PAYCHANGU_PAYMENT_CALLBACK_URL
          }?credentials=${encodeURIComponent(JSON.stringify(credentials))}`,
          return_url: `${
            process.env.REACT_APP_PAYCHANGU_PAYMENT_RETURN_URL
          }?credentials=${encodeURIComponent(JSON.stringify(credentials))}`,
          customer: {
            email: userDetails?.email,
            first_name: userDetails?.first_name,
            last_name: userDetails?.last_name,
          },
          customization: {
            title: "Wallet Funding",
            description: "Top-up Wallet",
          },
          meta: {
            uuid: userDetails?.id,
            response: "Paychangu",
          },
        });
      } else {
        toast.error("Payment initialization failed. Please try again.");
      }
    } catch (err) {
      handleValidationError(err, toast, "Funding failed to initialize. Please try again");
      setLoading(false);
      toast.error(
        "Checkout page could not be loaded. Please try again. If error persists, kindly contact support",
      );
    }
    // Optional: you can listen for their redirect and handle success/failed logic
  };

  const handleAddMoney = async (event) => {
    event.preventDefault();
    setLoading(true);

    if (!amount || isNaN(amount) || amount <= 0) {
      toast.error("Please enter a valid amount.");
      setLoading(false);
      return;
    }

    if (walletSelect === "") {
      toast.error("Please select a wallet.");
      setLoading(false);
      return;
    }

    const credentials = {
      amount: amount,
      provider: (selectedGatewayDetails?.code_name || selectedMethod).toLowerCase(),
      currency: userLocalWallet?.currency_code,
      wallet_id: userLocalWallet?.id,
    };
    // const walletRefId = userLocalWallet && userLocalWallet.ref_id;

    try {
      let paymentData;

      if (['anchor', 'bitnob'].includes(selectedMethod)) {
        try{
          const response = await initializeFunding(credentials);
          console.log(response.data.data);
          setVirtualAccount(response.data.data);
        }
        catch(error){
          handleValidationError(error, toast, "Failed to initialize funding. Please try again.");
          setLoading(false);
          return;
        }
        // close current modal
        closeMonnifyBtnRef.current.click();
        setLoading(false);

        // open modal to show the bank account details
        const modal = new Modal(document.getElementById("anchorBankDetailsModal"));
        modal.show();
        return;
      } 
      
      try{
        const response = await initializeFunding(credentials);
        paymentData = response.data.data;
      }
      catch(error){
        handleValidationError(error, toast, "Failed to initialize funding. Please try again.");
        setLoading(false);
        return;
      }
      
      if (paymentData.provider === "monnify") {
        await handleMonnifyPayment(paymentData);
      } else if (paymentData.provider === "paychangu") {
        await handlePaychanguPayment(paymentData);
      } else if (paymentData.provider === "payaza") {
        await handlePayAzaPayment(paymentData);
      } else {
        toast.error("Invalid payment method selected.");
      }
    } catch (err) {
      setLoading(false);
      const errorMessage = err?.response?.data?.message;
      toast.error(
        errorMessage || "An error occurred during funding. Please try again.",
      );
    } finally {
      // setLoading(false);
    }
  };

  useEffect(() => {
    handleCountrySelect(userDetails?.country_code);
  }, [selectedMethod]);

  return (
    <>
      <div id="wrapper"></div>
      <section
        className="main  add_money-section"
        style={{ paddingTop: "100px" }}
      >
        <div className="container-fluid">
          {/* <div className="d-flex align-items-center mb-4">
          <button onClick={() => window.history.back()} className="btn btn-sm" style={{ color: '#777' }}>
            <FaAngleLeft size={15} />
            <span className="ms-1 small mt-1">Go back</span>
          </button>
        </div> */}

          <div className="add_money-header">
            <h2>Fund your wallet</h2>
            <p className="mb-0 mx-auto" style={{ maxWidth: "500px" }}>
              {gateways.length > 0 && <>
                Choose your preferred payment method to add funds to your account
                securely.
              </>}
            </p>
          </div>

          <section className="gateway-grid">
            {gatewayLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : gateways && gateways.length > 0 ? (
              gateways.map((gateway) =>
                <div
                  key={gateway.id}
                  className={`gateway-selector-card ${
                    selectedMethod === gateway.code_name ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedMethod(gateway.code_name);
                    setSelectedPaymentProvider(gateway);
                    computeTransactionFee(amount, gateway);
                  }}
                >
                  <div className="gateway-info">
                    {['anchor', 'bitnob'].includes(gateway.code_name) ? <>
                      <div className="gateway-icon-wrapper">
                        <div className="default-icon">VA</div>
                      </div>
                      <h6 className="gateway-name">
                        Bank Transfer
                      </h6>
                    </> : <>
                      <div className="gateway-icon-wrapper">
                        {gateway.favicon ? (
                          <img src={gateway.favicon} alt={gateway.code_name} />
                        ) : gateway.code_name === "monnify" ? (
                          <img src={monnifyIcon} alt={gateway.code_name} />
                        ) : gateway.code_name === "paychangu" ? (
                          <img src={paychanguIcon} alt="icon" />
                        ) : (
                          <div className="default-icon">{gateway.code_name[0]}</div>
                        )}
                      </div>
                      <h6 className="gateway-name">
                        Debit Card/Others
                      </h6>
                    </>}
                  </div>
                  <div className="selection-indicator"></div>
                </div>)
            ) : (
              <div className="text-center py-5">
                <p className="text-muted">
                  {!nigerianUser ? <>
                    No deposit options available at the moment.
                  </> : userDetails?.virtual_account_holder && userDetails?.virtual_account_holder.kyc_status != 'failed' ? <>
                    {userDetails?.virtual_account_holder.kyc_status?.toLowerCase() === 'pending' ? (
                      <>Virtual account creation currently processing</>
                    ) : (
                      <>Your virtual account set-up is currently {userDetails?.virtual_account_holder.kyc_status}.</>
                    )}
                  </> : <>
                    A virtual bank account has not yet been assigned to your account yet. 
                    This may be because KYC verification is still pending. If you've completed that,
                    kindly reach out to our support team for assistance.
                  </>}
                </p>
              </div>
            )}

            {/* <label role='button' className="card mb-3 border-0 shadow-sm w-100" onClick={() => setSelectedMethod('Monnify')}>
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <img src={monnifyIcon} alt='icon' className='img-fluid rounded-circle' width='25px' height='25px'/>
                </div>
                <h6 className='mb-0'>Deposit with Monnify</h6>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="transferType"
                  value='Monnify'
                  checked={selectedMethod === 'Monnify'}
                  onChange={() => handleMethodChange('Monnify')}
                />
              </div>
            </div>
          </label> */}
            {/* <label role='button' className="card mb-3 border-0 shadow-sm w-100" onClick={() => setSelectedMethod('Paychangu')}>
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <img src={paychanguIcon} alt='icon' className='img-fluid rounded-circle' width='25px' height='25px'/>
                </div>
                <h6 className='mb-0'>Deposit with Paychangu</h6>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="transferType"
                  value='PayChangu'
                  checked={selectedMethod === 'PayChangu'}
                  onChange={() => handleMethodChange('PayChangu')}
                />
              </div>
            </div>
          </label> */}
            {/* <label role='button' className="card mb-3 border-0 shadow-sm w-100" onClick={() => setSelectedMethod('anchor')}>
            <div className="card-body d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center">
                <div className="me-3">
                  <img src={anchorIcon} alt='icon' className='img-fluid rounded-circle' width='25px' height='25px'/>
                </div>
                <h6 className='mb-0'>Deposit with Anchor</h6>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="transferType"
                  value='Anchor'
                  checked={selectedMethod === 'Anchor'}
                  onChange={() => handleMethodChange('Anchor')}
                />
              </div>
            </div>
          </label> */}

            <div className="d-flex align-items-center justify-content-center mt-4">
              <button
                className="confirm-action-btn"
                disabled={!selectedMethod || gateways.length < 1}
                data-bs-toggle="modal"
                data-bs-target="#addMoneyModal"
              >
                Continue
              </button>
            </div>
          </section>

          {/* Add Money Modal */}
          <section
            className="modal fade"
            id="addMoneyModal"
            tabIndex="-1"
            aria-labelledby="addMoneyModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content position-relative">
                <div
                  className="d-flex justify-content-end pe-3 pt-3"
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "3px",
                    zIndex: 1,
                  }}
                >
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    ref={closeMonnifyBtnRef}
                  ></button>
                </div>
                <div className="modal-header-custom">
                  <h4 className="mb-0">
                    Add Money
                  </h4>
                </div>
                <div className="modal-body-custom">
                  <form onSubmit={handleAddMoney}>
                    <div className="custom-select">
                      <div className="form__card-section">
                        <div className="d-none">
                          <div className="mb-4">
                            <label className="form-label mb-0">
                              Payment wallet:{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="form-select"
                              role="button"
                              value={walletSelect}
                              onChange={handleWalletSelectChange}
                              disabled
                            >
                              <option value="">Select a source</option>
                              {loading ? (
                                <option>Loading...</option>
                              ) : userLocalWallet ? (
                                <option value={userLocalWallet.id}>
                                  {/* {userLocalWallet.currency} ({userLocalWallet.currencyName}) */}
                                  {userLocalWallet.currency_code} (
                                  {userLocalWallet.currencyName})
                                </option>
                              ) : (
                                <option>No local wallet found</option>
                              )}
                            </select>
                          </div>
                        </div>

                        <div className="mb-4">
                          <label className="form-label-custom">
                            Amount to Fund{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="input-group">
                            <span className="input-group-text flag-select-wrapper">
                              <ReactFlagsSelect
                                selectedSize={20}
                                showSelectedLabel={false}
                                selected={selectedCountry}
                                onSelect={handleCountrySelect}
                                customLabels={customLabels}
                                countries={allowedCountries}
                                className="menu-flags"
                                selectButtonClassName="menu-flags-button"
                                disabled
                              />
                            </span>
                            <input
                              type="number"
                              className="form-control input-modern amount-input-modern"
                              placeholder="0.00"
                              value={amount}
                              onChange={handleAmountChange}
                              min="1"
                            />
                          </div>
                        </div>

                        <div className="mb-4">
                          {appliedFees?.length > 0 && Number(totalFees) > 0 && <>
                            {/* You pay */}
                            <div className="d-flex justify-content-between align-items-center py-3">
                              <span style={{ color: '#666', fontSize: '15px' }}>You Send</span>
                              <span style={{ fontSize: '15px', fontWeight: '600' }} className="d-flex align-items-center fee-value fee-primary">
                                {userLocalWallet?.currency_code}{formatAmount(amount || 0)}
                              </span>
                            </div>
                
                            {/* Total fees */}
                            <div className="d-flex justify-content-between align-items-center pb-3">
                              <span style={{ color: '#666', fontSize: '15px' }} className="d-flex align-items-center">
                                Total fees (included)
                                <FaInfoCircle
                                  className="ms-2" 
                                  color="#aaa"
                                  onClick={() => setShowFeeDetails(!showFeeDetails)}
                                  style={{ cursor: 'pointer', fontSize: '0.9em' }}
                                />
                              </span>
                              <span style={{ fontSize: '15px', fontWeight: '500' }} className="fee-value fee-danger">
                                {userLocalWallet?.currency_code}{formatAmount(totalFees)}
                              </span>
                            </div>
  
                            {/* Expanded Fees */}
                            {showFeeDetails && appliedFees?.length > 0 && appliedFees.map((fee, index) => 
                              <div className="d-flex justify-content-between align-items-center pb-2" style={{ paddingLeft: '1rem', opacity: 0.8 }}>
                              {/* <div key={index} className="d-flex justify-content-between align-items-center pb-2" style={{ paddingLeft: '1rem', opacity: 0.8 }}> */}
                                <span style={{ color: '#888', fontSize: '14px' }}>
                                  {fee.label}
                                </span>
                                <span style={{ color: '#888', fontSize: '14px' }}>
                                  {fee.currency}{formatAmount(fee.totalAmount)}
                                </span>
                              </div>
                            )}
                          </>}

                          <div className="d-flex justify-content-between align-items-center py-3">
                            <span style={{ color: '#666', fontSize: '15px' }}>You will be credited</span>
                            <span style={{ fontSize: '15px', fontWeight: '600' }} className="d-flex align-items-center fee-value fee-success">
                              {userLocalWallet?.currency_code}{formatAmount(Number(amount) - Number(totalFees))}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <button
                      type="submit"
                      className="confirm-action-btn w-100 mt-4"
                      disabled={loading || !isEdited}
                    >
                      {loading ? (
                        <div
                          className="spinner-border spinner-border-sm text-light"
                          role="status"
                        >
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      ) : (
                        "Proceed to Payment"
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>

          {/* Anchor Funding Modal */}
          <section className="modal fade" id="anchorBankDetailsModal" tabIndex="-1" aria-labelledby="anchorBankDetailsModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content position-relative">
                <div className="d-flex justify-content-end pe-3 pt-3" style={{position: "absolute", top: "10px", right: "3px", zIndex: 1}}>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeAnchorBtnRef}></button>
                </div>
                <div className="modal-body px-3 px-sm-3 px-md-4 px-lg-5 mt-3 mt-sm-1">
                  <h4 className="mb-3 mb-md-4 mb-lg-4 text-center text-capitalize">
                    {" "}Bank Transfer Details{" "}
                  </h4>
                  <div className="custom-select">
                    <div className="form__card-section payment-card">
                      <div className="account-details">
                        <div className="account-details-grid">
                          <div className="detail-row-modern">
                            <div className="detail-content">
                              <span className="detail-label">Bank Name</span>
                              <span className="detail-value">
                                {virtualAccount.bank_name}
                              </span>
                            </div>
                            <button
                              className="copy-btn-modern"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  virtualAccount.bank_name,
                                );
                                toast.success("Bank name copied");
                              }}
                              title="Copy Bank Name"
                            >
                              <FiCopy size={18} />
                            </button>
                          </div>

                          <div className="detail-row-modern">
                            <div className="detail-content">
                              <span className="detail-label">
                                Account Number
                              </span>
                              <span className="detail-value">
                                {virtualAccount.account_number}
                              </span>
                            </div>
                            <button
                              className="copy-btn-modern"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  virtualAccount.account_number,
                                );
                                toast.success("Account number copied");
                              }}
                              title="Copy Account Number"
                            >
                              <FiCopy size={18} />
                            </button>
                          </div>

                          <div className="detail-row-modern">
                            <div className="detail-content">
                              <span className="detail-label">Account Name</span>
                              <span className="detail-value">
                                {virtualAccount.account_name}
                              </span>
                            </div>
                            <button
                              className="copy-btn-modern"
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  virtualAccount.account_name,
                                );
                                toast.success("Account name copied");
                              }}
                              title="Copy Account Name"
                            >
                              <FiCopy size={18} />
                            </button>
                          </div>
                        </div>
                        
                        <div className="fee-summary-section">
                          {virtualAccount.amount !== "" && (
                            <div className="fee-summary-row">
                              <span className="fee-label"> Amount To Send </span>
                              <span className="fee-value fee-primary">
                                {userDetails?.wallet?.currency_symbol || virtualAccount.currency}
                                {getFormattedAmount(virtualAccount.amount)}
                              </span>
                            </div>
                          )}
                          {virtualAccount.total_fees !== "" && (
                            <div className="fee-summary-row">
                              <span className="fee-label">Transaction Fee</span>
                              <span className="fee-value fee-danger">
                                {userDetails?.wallet?.currency_symbol || virtualAccount.currency}
                                {getFormattedAmount(virtualAccount.total_fees)}
                              </span>
                            </div>
                          )}
                          {virtualAccount.amount_to_be_credited !== "" && (
                            <div className="fee-summary-row">
                              <span className="fee-label">Amount to be Credited</span>
                              <span className="fee-value fee-success">
                                {userDetails?.wallet?.currency_symbol || virtualAccount.currency}
                                {virtualAccount.amount_to_be_credited}
                              </span>
                            </div>
                          )}
                        </div>

                        <div className="hint-footer">
                          <ShieldCheck size={20} />
                          <span> Transfers are confirmed automatically once received. </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>
    </>
  );
};

export default AddMoney;
